import React from 'react';

import Alert from 'components/Alert';
import { constants } from 'helpers/constants';

export default class Blinket {
  public static isBlinket = (partnerId: number) => partnerId === constants.productPartners.blinket;

  public static blinketModal = async () => {
    const confirm = await Alert.confirm({
      message: 'Essa configuração deve ser feita no Eduzz Eventos. Deseja continuar?',
      title: 'Produto Eduzz Eventos',
      confirmation: true,
      buttonOk: <>Ir para o Eduzz Eventos</>,
      buttonCancel: <>Cancelar</>
    });

    if (confirm) Blinket.openBlinket();
  };

  public static openBlinket = () => window.open('https://app.blinket.com.br', '_blank');
}
